import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

/**
 * Components
 */
import InputPassword from '@pedidosya/web-fenix/system/InputPassword';
import PasswordRulesList from './components/PasswordRulesList';

const Container = styled.div``;

const PasswordRulesInput = ({
  id,
  label,
  value,
  onChange,
  rules,
  successMessage,
}) => {
  const [passwordFocus, setPasswordFocus] = useState(false);

  const handleBlur = () => {
    setPasswordFocus(false);
  };

  const handleFocus = () => {
    setPasswordFocus(true);
  };

  return (
    <Container>
      <InputPassword
        id={id}
        label={label}
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        data-testid="password-input"
      />
      <PasswordRulesList
        rules={rules}
        showSuccessMessage={!passwordFocus}
        successMessage={successMessage}
      />
    </Container>
  );
};

PasswordRulesInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  rules: PropTypes.array,
  successMessage: PropTypes.string,
};

PasswordRulesInput.defaultProps = {
  rules: [],
  successMessage: '',
};

export default PasswordRulesInput;
